export default "__VITE_ASSET__81d32d4f__"